export default __webpack_public_path__ + "static/media/input-attention.f51e8bfe.svg";